module.exports = __webpack_public_path__ + "static/img/d1.2b92b00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/d1.png
// module id = 2Vcc
// module chunks = 0